/* eslint-disable */

function getSubdomain  ()  {
  const host = window.location.hostname;   // e.g. restaurant.localhost
  const parts = host.split(".");

  // If localhost with subdomain = restaurant.localhost → "restaurant"
  if (host.includes("localhost")) {
    return parts.length > 1 ? parts[0] : null;
  }

  // For real domains -> pick first part
  return parts[0]; 
};

export const storeLoginData = (data) => {
  try {
    console.log(data)
    localStorage.setItem(`loginData-${getSubdomain()}`, JSON.stringify(data));
  } catch (error) {
    console.error("Error storing login data:", error);
  }
};

// Retrieve login data from localStorage
export const getLoginData = () => {
  try {
    const loginData = localStorage.getItem(`loginData-${getSubdomain()}`);
    return loginData ? JSON.parse(loginData) : null;
  } catch (error) {
    console.error("Error getting login data:", error);
    return null;
  }
};

// Remove login data from localStorage
export const removeLoginData = () => {
  try {
    localStorage.removeItem("loginData");
  } catch (error) {
    console.error("Error removing login data:", error);
  }
};

// Check if login data exists in localStorage
export const isLoggedIn = () => {
  try {
    return localStorage.getItem("loginData") !== null;
  } catch (error) {
    console.error("Error checking login status:", error);
    return false;
  }
};
